import { type BoundActions, createHook, type HookFunction } from 'react-sweet-state';

import type { FeedbackStoreActions } from './FeedbackStoreActions';
import type { FeedbackStoreState } from './FeedbackStoreState';
import { store } from './store';

export const useFeedbackCollector: HookFunction<
	FeedbackStoreState,
	BoundActions<FeedbackStoreState, FeedbackStoreActions>,
	void
> = createHook(store);
